module.exports = __webpack_public_path__ + "img/4.3f1afb32.png";